import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as CommunityActionCreators from '../../actions/community'
import * as DoorAccessActionCreators from '../../actions/doorAccess'

import CommunityDoorAccessList from './CommunityDoorAccessList'
import CommunityGrantDoorAccessDialog from './CommunityGrantDoorAccessDialog'

import { getDoorAccessesByCommunityId } from '../../utils/DoorAccesses'

class CommunityAccessControlContainer extends React.Component {
  static propTypes = {
    /* passed props */
    communityId: PropTypes.number.isRequired,
    /* mapped state */
    doorAccesses: PropTypes.object.isRequired,
    doorAccessesByCommunity: PropTypes.object.isRequired,
    doorAccessesByUnit: PropTypes.object.isRequired,
    uiConfig: PropTypes.object.isRequired,
    unitsByCommunity: PropTypes.object.isRequired,
    /* mapped dispatch */
    communityActions: PropTypes.object.isRequired,
    doorAccessActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      doorAccesses: state.doorAccesses,
      doorAccessesByCommunity: state.doorAccessesByCommunity,
      doorAccessesByUnit: state.doorAccessesByUnit,
      uiConfig: state.uiConfig,
      unitsByCommunity: state.unitsByCommunity,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  state = {
    accessIds: [],
    checkedIds: [],
  }

  componentDidMount() {
    const { communityId, communityActions, doorAccessActions } = this.props

    doorAccessActions.listCommunityDoorAccesses(communityId)
    doorAccessActions.listCommunityDoorAccessIds(communityId)
    communityActions.listCommunityUnits(communityId)
  }

  componentDidUpdate(_, prevState) {
    const unitIds = this.props.unitsByCommunity[this.props.communityId]
    unitIds.map((id) => this.props.doorAccessActions.listUnitDoorAccessIds(id))

    const accessIds = this.getDoorAccessesByUserId().map((u) => u.accessId)
    if (JSON.stringify(prevState.accessIds) !== JSON.stringify(accessIds)) {
      this.updateCheckboxIds(accessIds)
    }
  }

  updateCheckboxIds = (accessIds) => {
    this.setState(
      (prevState) => ({
        accessIds,
        checkedIds: accessIds.filter((id) => prevState.checkedIds.includes(id)),
      }),
    )
  }

  handleToggleCheckAll = (_, checked) => {
    this.setState(
      (prevState) => ({
        checkedIds: checked ? prevState.accessIds : [],
      }),
    )
  }

  handleToggleCheckbox = (checked, accessId) => {
    const index = this.state.checkedIds.indexOf(accessId)

    if (checked && index === -1) {
      this.setState(
        (prevState) => ({
          checkedIds: [...prevState.checkedIds, accessId],
        }),
      )
    } else {
      this.setState(
        (prevState) => ({
          checkedIds: prevState.checkedIds.filter((item) => item !== accessId),
        }),
      )
    }
  }

  getUnitAccessByUserId = () => {
    const {
      communityId,
      doorAccessesByUnit,
      unitsByCommunity,
    } = this.props

    const unitAccessByUserId = {}

    // doorAccessesByUnit might include other communities' units;
    // We only want those of the current community
    const unitIds = unitsByCommunity[communityId] || []

    unitIds.forEach((unitId) => {
      const unitAccessIds = doorAccessesByUnit[unitId] || []
      unitAccessIds.forEach((accessId) => {
        unitAccessByUserId[accessId] = unitAccessByUserId[accessId] || []
        unitAccessByUserId[accessId].push(unitId)
      })
    })

    return unitAccessByUserId
  }

  getDoorAccessesByUserId = () => {
    const {
      communityId,
      doorAccesses,
      doorAccessesByCommunity,
    } = this.props

    const communityDoorAccesses = getDoorAccessesByCommunityId(doorAccesses, communityId)
    const communityAccessIds = doorAccessesByCommunity[communityId] || []
    const unitAccessByUserId = this.getUnitAccessByUserId()
    const userDoorAccesses = []

    Object.keys(communityDoorAccesses).map((userId) => userDoorAccesses.push({
      accessId: parseInt(userId, 10),
      hasCommunityAccess: communityAccessIds.includes(parseInt(userId, 10)),
      unitIds: unitAccessByUserId[userId] || [],
    }))

    return userDoorAccesses
  }

  render() {
    const { communityId, uiConfig } = this.props

    if (uiConfig.showDoorAccessUI) { // role-based perms
      return (
        <>
          <CommunityDoorAccessList
            accessIds={this.state.accessIds}
            checkedIds={this.state.checkedIds}
            communityId={communityId}
            onToggleCheckAll={this.handleToggleCheckAll}
            onToggleCheckbox={this.handleToggleCheckbox}
            rows={this.getDoorAccessesByUserId()}
          />
          <CommunityGrantDoorAccessDialog communityId={communityId} />
        </>
      )
    }

    return null
  }
}

export default connect(
  CommunityAccessControlContainer.mapStateToProps,
  CommunityAccessControlContainer.mapDispatchToProps,
)(CommunityAccessControlContainer)
